import { Customer } from '~/api';
import { FormItemProps } from '~/components/FormBuilder/props';
import { useTranslate } from '@refinedev/core';
import { REGEX_EMAIL } from '../constant';
import { useOutletsCache } from '~/providers/Cache/useCache';

export const customerFormBuilder = (customer?: Customer): FormItemProps[] => {
  const { id, firstName, lastName, emailAddress, phoneNumber, customFields } = customer || {};
  const { gender, dateOfBirth, preferredOutletId } = customFields || {};

  const t = useTranslate();
  const { outlets: { data: outletsData, isLoading } } = useOutletsCache();
  const outlets = outletsData?.getOutlets?.items || [];

  return [
    {
      title: t('customer.form.firstName'),
      name: 'firstName',
      defaultValue: firstName,
      placeholder: t('customer.placeholder.firstName'),
    },
    {
      title: t('customer.form.lastName'),
      name: 'lastName',
      defaultValue: lastName,
      placeholder: t('customer.placeholder.lastName'),
    },
    {
      title: t('customer.form.email'),
      name: 'emailAddress',
      defaultValue: emailAddress,
      placeholder: t('customer.placeholder.email'),
      // TODO: allow edit email address (Kedai & NP)
      props: {
        disabled: !!emailAddress,
        pattern: REGEX_EMAIL,
      },
    },
    {
      title: t('customer.form.contact'),
      name: 'phoneNumber',
      defaultValue: phoneNumber,
      type: 'phone',
      placeholder: t('customer.placeholder.contact'),
      required: true,
      // TODO: allow edit phone number (Kedai & NP)
      props: {
        disabled: !!phoneNumber,
      },
    },
    {
      // temporary text input
      title: t('customer.form.dateOfBirth'),
      name: 'birthDate',
      placeholder: t('customer.placeholder.dateOfBirth'),
      type: 'date-text-input',
      defaultValue: dateOfBirth,
    },
    {
      title: t('customer.form.gender'),
      name: 'gender',
      type: 'radio',
      options: ['MALE', 'FEMALE'].map((value) => ({
        label: t(`customer.gender.${value.toLowerCase()}`),
        value,
      })),
      defaultValue: gender,
    },
    {
      title: t('customer.form.preferredOutlet'),
      name: 'preferredOutletId',
      type: 'select',
      placeholder: t('customer.placeholder.preferredOutlet', 'Select preferred outlet'),
      defaultValue: preferredOutletId || '',
      options: isLoading 
        ? []
        : outlets.map((outlet) => ({
            label: outlet.name,
            value: outlet.id,
          })),
    },
  ];
};
